/* eslint-disable react/prop-types */
import React from "react";
import classNames from "classnames";
import { useQueryParam, StringParam } from "use-query-params";

import { IFooter, ISite, Vendor } from "../../interfaces";
import { ComponentBroker, SectionBroker } from "../brokers";
import CmsMarkdown from "../basic/cms-markdown";
import SocialMediaLinks from "./social-media-links";
import { authEnabled } from "../../utils/auth";
import { COMPONENTS } from "../../constants";

import "../../styles/social-icons.base.scss";
import * as styles from "./styles.module.scss";

interface Props {
  footer: IFooter;
  site: ISite;
}

const CmsFooter = (props) => {
  const footer = props.footer?.data?.attributes;
  const { copyright, social_links, top_content: topContent }: IFooter = footer || {};
  let { information }: IFooter = footer || {};
  const [displayVersion] = useQueryParam("version", StringParam);
  const displayNav = displayVersion !== "print";

  information = information?.filter(
    (el) =>
      displayNav ||
      (!displayNav && ![COMPONENTS.LINK_LIST, COMPONENTS.SITE_SEARCH].includes(el.__typename))
  );

  return (
    <footer>
      <div className="top-content">
        {topContent?.map((item) => {
          return <SectionBroker key={`${item.id}-${item.__typename}`} section={item} />;
        })}
      </div>
      <div className={classNames(`information`, styles.information)}>
        <div className="container-lg p-responsive d-flex flex-column flex-md-row flex-justify-between py-7 ">
          {information?.map((item) => {
            return <ComponentBroker key={`${item.id}-${item.__typename}`} component={item} />;
          })}
        </div>
        {social_links?.length > 0 && (
          <div className={classNames(`social_container`, styles.social_container)}>
            <SocialMediaLinks links={social_links} />
          </div>
        )}
        {displayNav && authEnabled() && (
          <div className={classNames(styles.producer_login, "py-2 producer_login")}>
            <a href="/login">PRODUCER SECURE SITE</a>
          </div>
        )}
      </div>
      <div className={classNames(`copyright_container`, styles.copyright_container)}>
        <div className={classNames(styles.copyright, "container-lg p-responsive py-2 copyright")}>
          {copyright && <CmsMarkdown content={copyright} />}
        </div>
      </div>
    </footer>
  );
};

export default CmsFooter;
